import React from 'react';
export function EmojiIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M19 0h2v3h3v2h-3v3h-2V5h-3V3h3V0zm1 12a8 8 0 11-7-7.938V2.049A10.318 10.318 0 0012 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.338-.017-.671-.05-1h-2.012c.041.328.062.661.062 1z"
  }), React.createElement("path", {
    d: "M8 8a1 1 0 112 0v2a1 1 0 11-2 0V8zm6 0a1 1 0 112 0v2a1 1 0 11-2 0V8zm-2 10c-2.608 0-4.75-2.197-4.98-5h9.96c-.23 2.803-2.372 5-4.98 5z"
  }));
}